import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { computed } from "@ember/object"
import { inject as service } from "@ember/service"
import { calculateCourseDateCombined } from "@shared/lib/course-date-combined"
import type { Course } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import type { RotationCalendar } from "@shared/models/rotation-calendar"
import type PhantomCardStacks from "cc-frontend/services/phantom-card-stacks"

@tagName("")
export default class CourseDateCombinedComponent extends Component {
  dateString!: string
  rotationCalendar!: RotationCalendar
  course!: Course
  planbook!: Planbook

  @service phantomCardStacks!: PhantomCardStacks

  @computed(
    "dateString",
    "course.attributes.calendar.dateAnnotations.[]",
    "course.attributes.calendar.datesOff.[]",
    "course.attributes.calendar.version",
    "planbook.attributes.calendar.datesOff.[]",
    "planbook.attributes.calendar.version",
    "rotationCalendar.attributes.dates"
  )
  get courseDateCombined() {
    return calculateCourseDateCombined(
      this.dateString,
      this.course,
      this.planbook,
      this.rotationCalendar,
      (courseId, dateString) => this.phantomCardStacks.findCardStackIdForDate(courseId, dateString)
    )
  }
}
